import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ApplyFormService} from "../../../../shared/services/apply-form.service";
import {AlertService} from "../../../../shared/services/alert.service";
import Swal from 'sweetalert2';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-apply-form',
    templateUrl: './apply-form.component.html',
    styleUrls: ['./apply-form.component.scss'],
})
export class ApplyFormComponent implements OnInit {

    pcbMappings = [];
    programs = [];
    courses = [];
    branches = [];
    url: any;
    filteredCourses: any[] = [];
    filteredBranch: any[] = [];
    showCourseDropdown = false;
    showBranchDropdown = false;
    countries = [
        {"id": 1, "name": "India", "code": "IN", "isd": "+91"},
        {"id": 2, "name": "United States", "code": "US", "isd": "+1"},
        {"id": 3, "name": "United Kingdom", "code": "GB", "isd": "+44"},
        {"id": 4, "name": "Canada", "code": "CA", "isd": "+1"},
        {"id": 5, "name": "Australia", "code": "AU", "isd": "+61"},
        {"id": 6, "name": "Germany", "code": "DE", "isd": "+49"},
        {"id": 7, "name": "France", "code": "FR", "isd": "+33"},
        {"id": 8, "name": "China", "code": "CN", "isd": "+86"},
        {"id": 9, "name": "Japan", "code": "JP", "isd": "+81"},
        {"id": 10, "name": "South Korea", "code": "KR", "isd": "+82"},
        {"id": 11, "name": "Brazil", "code": "BR", "isd": "+55"},
        {"id": 12, "name": "Russia", "code": "RU", "isd": "+7"},
        {"id": 13, "name": "South Africa", "code": "ZA", "isd": "+27"},
        {"id": 14, "name": "Mexico", "code": "MX", "isd": "+52"},
        {"id": 15, "name": "Indonesia", "code": "ID", "isd": "+62"},
        {"id": 16, "name": "Italy", "code": "IT", "isd": "+39"},
        {"id": 17, "name": "Spain", "code": "ES", "isd": "+34"},
        {"id": 18, "name": "Netherlands", "code": "NL", "isd": "+31"},
        {"id": 19, "name": "Sweden", "code": "SE", "isd": "+46"},
        {"id": 20, "name": "Singapore", "code": "SG", "isd": "+65"}
    ]


    constructor(private formBuilder: FormBuilder,
                private applyFormService: ApplyFormService,
                private alertService: AlertService,
                private router: Router,
                private cd: ChangeDetectorRef,) {
        this.url = this.router.url;
    }

    applyNowForm: FormGroup = new FormGroup({});

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.refresh();
    }

    refresh() {
        this.applyNowForm = this.formBuilder.group({
            'name': ['', Validators.required],
            'email': ['', Validators.required],
            'country_id': ['',],
            'isd': [''],
            'school_id': ['', Validators.required],
            'program_id': ['', Validators.required],
            'course_id': ['', Validators.required],
            'branch_id': [''],
            'selectedCourse': [''],
            'selectedBranch': [''],
            'contact': ['', Validators.required],
        });

        this.getPcb();
    }

    getPcb(): void {
        this.filteredCourses = this.filteredBranch = this.courses = this.branches = null;
        this.applyNowForm.patchValue({
            'course_id': '',
            'branch_id': '',
            'selectedCourse': '',
            'selectedBranch': ''
        })
        this.applyFormService.pcb_mapping().subscribe(data => {
                this.pcbMappings = data['data'];
                this.programs = data['data'];
                this.programs = this.programs.filter(
                    (value, index, self) =>
                        index ===
                        self.findIndex((t) => t.program?.name === value?.program?.name)
                );
            }
        )
    }

    getCourses(): void {
        this.filteredBranch = this.branches = null;
        let program = this.applyNowForm?.value?.program_id;
        this.applyNowForm.patchValue({
            'branch_id': '',
            'selectedBranch': ''
        })
        this.courses = this.pcbMappings.filter(value => value.program?.id == program);
        this.courses = this.courses.filter(
            (value, index, self) =>
                index ===
                self.findIndex((t) => t.course?.name === value?.course?.name)
        );
        this.filteredCourses = this.courses;
    }

    getBranches() {
        let schoolId = this.pcbMappings.filter(value => (value.program?.id == this.applyNowForm.value.program_id) && (value.course?.id == this.applyNowForm.value.course_id))[0].school?.id
        this.applyNowForm.patchValue({
            'school_id': schoolId
        })
        let course = this.applyNowForm?.value?.course_id;
        this.branches = this.pcbMappings.filter(value => value.course?.id == course);
        this.branches = this.branches.filter(
            (value, index, self) =>
                index ===
                self.findIndex((t) => t.branch?.name === value?.branch?.name)
        );
        this.filteredBranch = this.branches;
    }

    submit() {
        if (!(this.applyNowForm?.valid)) {
            this.alertService.showErrors('All fields are required!');
            return false;
        }
        const params = {
            'name': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().name && this.applyNowForm.getRawValue().name,
            'email': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().email && this.applyNowForm.getRawValue().email,
            'country_id': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().country_id && this.applyNowForm.getRawValue().country_id,
            'isd': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().isd && this.applyNowForm.getRawValue().isd,
            'contact': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().contact && this.applyNowForm.getRawValue().contact,
            'school_id': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().school_id && this.applyNowForm.getRawValue().school_id,
            'program_id': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().program_id && this.applyNowForm.getRawValue().program_id,
            'course_id': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().course_id && this.applyNowForm.getRawValue().course_id,
            'branch_id': this.applyNowForm && this.applyNowForm.getRawValue() && this.applyNowForm.getRawValue().branch_id && this.applyNowForm.getRawValue().branch_id,
        }
        this.applyFormService.add(params).subscribe(data => {
            this.applyNowForm.reset();
        }, error => {
            console.log(error);
        })
    }

    filterCourses(search: string): void {
        this.filteredBranch = this.branches = null;
        this.filteredCourses = this.courses?.filter(c =>
            c?.course?.name?.toLowerCase().includes(search.toLowerCase())
        );
        this.filteredCourses = this.filteredCourses.slice(0, 10);
    }

    selectCourse(course: any): void {
        this.applyNowForm.patchValue({
            'course_id': course?.course?.id,
            'selectedCourse': course?.course?.name,
            'branch_id': '',
            'selectedBranch': '',
        })
        this.filteredCourses = [];
        this.getBranches();
    }

    filterBranch(search: string): void {
        this.filteredBranch = this.branches?.filter(c =>
            c?.branch?.name?.toLowerCase().includes(search.toLowerCase())
        );
    }

    selectBranch(branch: any): void {
        if (branch && branch.branch) {
            this.applyNowForm.patchValue({
                'branch_id': branch?.branch?.id,
                'selectedBranch': branch?.branch?.name
            });
            this.filteredBranch = [];
        }
    }

    hideDropdownWithDelay(type: any) {
        // Delay hiding to allow click event on dropdown
        if (type == 'COURSE') {
            setTimeout(() => this.showCourseDropdown = false, 150);
        } else if (type == 'BRANCH') {
            setTimeout(() => this.showBranchDropdown = false, 150);
        }

    }
}
